'use client';

import { createContext, useContext, ReactNode } from 'react';
import { IMarketArticlesData } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Articles/IMarketArticle';
import useArticles from './useArticles';

type ArticlesContextType = ReturnType<typeof useArticles>;

export const ArticlesContext = createContext<ArticlesContextType>(null);

export const useArticlesContext = () => {
  const context = useContext(ArticlesContext);

  if (!context) {
    throw new Error('useArticlesContext must be used within the ArticlesContext');
  }

  return context;
};

interface IProps {
  articlesData: IMarketArticlesData,
  children: ReactNode,
}

const ArticlesContextProvider = ({ children, articlesData }: IProps) => (
  <ArticlesContext.Provider value={ useArticles(articlesData) }>
    { children }
  </ArticlesContext.Provider>
);

export default ArticlesContextProvider;
